export default __webpack_public_path__ + "static/media/breadcrumb-truncate.01a74764.svg";